export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_complete_2.ea8da887.jpg";